
module.constant('dolRegionStates', {
    "AK": 6,
    "AL": 3,
    "AR": 4,
    "AS": null,
    "AZ": 6,
    "CA": 6,
    "CO": 4,
    "CT": 1,
    "DC": 2,
    "DE": 2,
    "FL": 3,
    "FM": null,
    "GA": 3,
    "GU": 6,
    "HI": 6,
    "IA": 5,
    "ID": 6,
    "IL": 5,
    "IN": 5,
    "KS": 5,
    "KY": 3,
    "LA": 4,
    "MA": 1,
    "MD": 2,
    "ME": 1,
    "MH": null,
    "MI": 5,
    "MN": 5,
    "MO": 5,
    "MP": null,
    "MS": 3,
    "MT": 4,
    "NC": 3,
    "ND": 4,
    "NE": 5,
    "NH": 1,
    "NJ": 1,
    "NM": 4,
    "NV": 6,
    "NY": 1,
    "OH": 5,
    "OK": 4,
    "OR": 6,
    "PA": 2,
    "PR": 1,
    "PW": null,
    "RI": 1,
    "SC": 3,
    "SD": 4,
    "TN": 3,
    "TX": 4,
    "UT": 4,
    "VA": 2,
    "VI": 1,
    "VT": 1,
    "WA": 6,
    "WI": 5,
    "WV": 2,
    "WY": 4,
});

module.constant('dolRegionNames', [
    'Boston',
    'Philadelphia',
    'Atlanta',
    'Dallas',
    'Chicago',
    'San Francisco'
]);
